import { plural } from '@/utility/functions';

Alpine.data('alpine_item_lists', () => ({
  itemLists: [],
  isItemListsLoading: true,
  itemListKeyword: null,

  async fetchItemLists() {
      this.isItemListsLoading = true;

      await window.axios.get('/account/item-lists')
          .then(response => {
              this.itemLists = response.data;
          })
          .catch(error => console.error(error))
          .finally(() => this.isItemListsLoading = false);
  },

  get visibleItemLists() {
    if(this.itemLists.length === 0) {
      return [];
    }

    return this.itemLists.filter(itemList => {
      if(!this.itemListKeyword) {
        return true;
      }
      return itemList.name.match(new RegExp(this.itemListKeyword, 'gi'));
    });
  },

  plural: plural,

  async init() {
      await this.fetchItemLists();
  },
}));
